import { render } from "./EMagazinePages.vue?vue&type=template&id=74f70e24"
import script from "./EMagazinePages.vue?vue&type=script&lang=js"
export * from "./EMagazinePages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__